/**
 * rc136 — Tema claro/oscuro como store compartido.
 *
 * Antes vivía como useState dentro del Topbar; en móvil el botón de tema se
 * mueve al pie del menú (Sidebar) y los dos tienen que verse sincronizados.
 * Un store mínimo con useSyncExternalStore evita meter zustand para esto.
 */
import { useSyncExternalStore } from "react";

const KEY = "byteisp.theme";
const listeners = new Set<() => void>();

function leerInicial(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const saved = localStorage.getItem(KEY);
    if (saved) return saved === "dark";
  } catch {
    /* sin storage */
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

let isDark = leerInicial();
aplicar(isDark);

function aplicar(dark: boolean) {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark", dark);
  try {
    localStorage.setItem(KEY, dark ? "dark" : "light");
  } catch {
    /* sin storage */
  }
}

export function setDark(dark: boolean) {
  if (dark === isDark) return;
  isDark = dark;
  aplicar(dark);
  listeners.forEach((l) => l());
}

export function toggleDark() {
  setDark(!isDark);
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function useDarkMode() {
  const dark = useSyncExternalStore(subscribe, () => isDark, () => false);
  return { isDark: dark, toggle: toggleDark };
}
